import { EntityProfilePlaceholderTab } from '@features/Shared/EntityProfile/EntityProfilePlaceholderTab'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslations } from '@utils/i18n-to-migrate'

export const Route = createFileRoute('/framework/forestowner/$forestownerId/assignments')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Oppdrag',
  },
})

function RouteComponent() {
  const { t } = useTranslations()
  return (
    <EntityProfilePlaceholderTab
      title={t('forestowner-search-overview.tabs.assignments')}
      description={t('framework-forestownersandbox.placeholderDescription')}
    />
  )
}
